import {Grid, Icon, Stack, Text} from "@mbank-design/design-system/components";
import React, { useContext } from "react";
import {FlagStartColor} from "@mbank-design/design-system/icons";
import ParkingSection from "./ParkingSection";
import HotelSection from "./HotelSection";
import BanquetSection from "./BanquetSection";
import { AdditionalSupportContext } from "./AdditionalSupportContext";

export default function AdditionalSupportSection() {
    const { showParking, showHotel, showBanquet } = useContext(AdditionalSupportContext);
    if (showParking || showHotel || showBanquet) {
        return (
            <Stack>
                <Text as="h2">additional preferences</Text>
                <Grid>
                    <Grid.Row>
                        <Grid.Column span={1}>
                            <Icon iconComponent={FlagStartColor} size={24} />
                        </Grid.Column>
                        <Grid.Column span={11}>
                            <Text fontFamily="Montserrat" lineClamp={2}>please check all that apply:</Text>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <ParkingSection />
                <HotelSection />
                <BanquetSection />
            </Stack>
        );
    } else return <></>
} 